import {
    CLEAR_TEASERBOXES,
    FETCH_TEASERBOXES_FULFILLED,
    FETCH_TEASERBOXES_PENDING,
    FETCH_TEASERBOXES_REJECTED,
} from './action-types'

export interface ITeaserBoxState {
    failed: boolean;
    items: any[];
    loading: boolean;
    fetchHasBeenInitialized: boolean;
}

const initialState: ITeaserBoxState = {
    failed: false,
    items: [],
    loading: false,
    fetchHasBeenInitialized: false
};

export const teaserboxesReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_TEASERBOXES_PENDING:
            return {
                ...state,
                loading: true,
                fetchHasBeenInitialized: true,
            };

        case FETCH_TEASERBOXES_REJECTED:
            return {
                ...state,
                failed: true,
                loading: false,
            };

        case FETCH_TEASERBOXES_FULFILLED:
            return {
                ...state,
                loading: false,
                failed: false,
                items: action.payload.data,
            };

        case CLEAR_TEASERBOXES:
            return {
                ...initialState,
            };

        default:
            return state
    }
};

export default teaserboxesReducer
